/**
 * El nombre visible del producto es Boina Finance. El repositorio y la
 * documentación siguen llamándose "Gestión Veterinaria" por historia, pero eso
 * es interno: la persona que abre la aplicación ve la marca del logo.
 */
export const APP_NAME = 'Boina Finance';
export const PHASE = 'Fase 0 — fundaciones';

/**
 * A dónde escribe quien no puede entrar a su cuenta.
 *
 * Google Play pide una forma de pedir la baja de la cuenta a quien ya no puede
 * iniciar sesión —perdió la contraseña, le cambiaron el correo, se quedó
 * afuera—. Para esa persona la página de `/baja` no sirve: le pide entrar, y no
 * puede. Sin esta dirección no tiene ninguna salida.
 *
 * **Es una dirección pública.** Aparece en la página de baja y en la ficha de
 * la tienda, así que la ve cualquiera. Cambiarla más adelante no cuesta nada
 * —no es como el identificador de la aplicación, que es para siempre—: se
 * cambia acá y se actualiza en la Consola.
 *
 * Si alguna vez queda vacía, la página de baja NO promete un canal que no
 * existe: el párrafo directamente no se dibuja. Decir «escribinos» sin decir a
 * dónde deja a esa persona donde mismo estaba, y encima suena a que hay una
 * salida.
 */
export const CORREO_DE_SOPORTE = 'thebull.dz25@gmail.com';

/**
 * Dónde vive la aplicación en la web.
 *
 * No es un dato decorativo: es **a dónde vuelve** quien toca el enlace de un
 * correo. El teléfono no sirve como destino —adentro del envoltorio de Android
 * la aplicación no corre en una dirección pública— así que el enlace de
 * recuperar la contraseña tiene que apuntar a un lugar fijo y conocido, y éste
 * es ese lugar.
 */
export const SITIO_WEB = 'https://boinafinance.com';

/**
 * A dónde lleva el enlace de «olvidé mi contraseña».
 *
 * **Vuelve al mismo lugar desde donde se pidió**, cuando ese lugar es una
 * dirección pública. Es lo único que funciona siempre: la aplicación web vive
 * hoy en una dirección de Cloudflare y mañana en el dominio propio, y una
 * dirección escrita a mano acá manda a la gente al lugar equivocado durante
 * toda la mudanza. Pasó: el enlace salió apuntando al dominio el día que el
 * dominio todavía no resolvía.
 *
 * Desde el TELÉFONO no hay dirección pública —adentro del envoltorio de
 * Android la aplicación corre en `localhost`— así que ahí sí hace falta el
 * destino fijo. Lo mismo al desarrollar: un enlace a `localhost:5173` no lo
 * puede abrir nadie más que esta computadora.
 */
export function urlDeNuevaContrasena(): string {
  const { origin, protocol, hostname } = window.location;

  const esPublica = protocol === 'https:' && hostname !== 'localhost' && hostname !== '127.0.0.1';

  return `${esPublica ? origin : SITIO_WEB}/nueva-contrasena`;
}
